import { useRef } from "react";

export function Tip({ id, children, setHoveredTip, setTipRect, fullWidth = false }) {
  const wRef = useRef(null);
  return (
    <div
      ref={wRef}
      style={{
        position: "relative",
        display: fullWidth ? "flex" : "inline-flex",
        flex: fullWidth ? 1 : undefined,
        minWidth: fullWidth ? 0 : undefined,
        width: fullWidth ? "100%" : "auto",
      }}
      onMouseEnter={() => {
        if (wRef.current) setTipRect(wRef.current.getBoundingClientRect());
        setHoveredTip(id);
      }}
      onMouseLeave={() => {
        setHoveredTip(null);
        setTipRect(null);
      }}
    >
      {children}
    </div>
  );
}
